module.exports = __webpack_public_path__ + "img/hidro1.f60059f1.jpg";